import { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import Popup from "reactjs-popup";
import "react-quill/dist/quill.snow.css";
import modules from "../data/quill-modules";
import Select from "react-select";
import "../style/write/write.css";
import "reactjs-popup/dist/index.css";
import FileUploader from "./FileUploader";
import { useHistory, useParams } from "react-router-dom";
import axios from "../config/axios";
import { useTranslation } from "react-i18next";

function Write() {
    
    const { t } = useTranslation();
    const history = useHistory();
    const { postId } = useParams(); // Get postId from URL if editing
    const isEditing = !!postId;
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSelectChange = (selected) => {
        setSelectedOptions(selected);
    };
    const handleFilesUploaded = files => {
        // Assuming `files` is an array of Blob/File objects, select the first file
        const firstFile = files[0];

        if (firstFile instanceof Blob || firstFile instanceof File) {
            setBackgroundImage(firstFile);
            // Handle the uploaded file here
            console.log('Uploaded file:', firstFile);
        } else {
            // Handle the case where `files` does not contain a valid Blob/File object
            console.error('Invalid file:', files);
        }
    };


    const coloroptions = [
        {value: "Cognition", label: "Cognition"},
        {value: "Emotional Intelligence", label: "Emotional Intelligence"},
        {value: "Achievements", label: "Achievements"},
        {value: "Seasonal", label: "Seasonal"},
        {value: "Events by Sponsors", label: "Events by Sponsors"},
        {value: "Reading", label: "Reading"},
        {value: "Writing", label: "Writing"},
        {value: "Products", label: "Products"},
        {value: "Services", label: "Services"},
        {value: "Expressive Communication", label: "Expressive Communication"},
        {value: "Auditory Comprehension", label: "Auditory Comprehension"},
        {value: "Educational", label: "Educational"},
        {value: "Education Related", label: "Education Related"},
        {value: "Posts by Collaborators", label: "Posts by Collaborators"},
        {value: "Healthcare Related", label: "Healthcare Related"},
        {value: "Fine Motor Skills", label: "Fine Motor Skills"},
        {value: "Gross Motor Skills", label: "Gross Motor Skills"},
        {value: "Reflexes", label: "Reflexes"},
        {value: "Stationary Motor Skills", label: "Stationary Motor Skills"},
        {value: "Movements", label: "Movements"},
        {value: "Large Object Manipulation", label: "Large Object Manipulation"},
        {value: "Locomotion", label: "Locomotion"},
        {value: "Visual Motor Integration", label: "Visual Motor Integration"},
        {value: "Grasping", label: "Grasping"}

    ];
    //tag style
    const customStyles = {
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            color: state.isSelected ? '#FFFFFF' : '#6750A4',
            backgroundColor: state.isSelected ? '#E8DEF8' : '#FFFFFF',
        }),

        control: (defaultStyles) => ({
            ...defaultStyles,
            backgroundColor: '#FFFFFF',
            border: "none",
            boxShadow: "none",
        }),
        singleValue: (defaultStyles) => ({...defaultStyles, color: '#E8DEF8'}),
        multiValueLabel: (styles, {data}) => ({
            ...styles,
            color: '#6750A4',
            backgroundColor: '#E8DEF8',
        }),
        multiValueRemove: (styles, {data}) => ({
            ...styles,
            color: '#6750A4',
            backgroundColor: '#E8DEF8',
            ':hover': {
                backgroundColor: '#E8DEF8',
                color: '#17202A',

            },
        }),
    };
//tag
    const [titleText, setTitleText] = useState({
        title: "",
        subtitle: ""
    })

    const [mainText, setMainText] = useState("")
    //const [isClicked, setIsClicked] = useState(false)
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [existingThumbnail, setExistingThumbnail] = useState(null);
    const [wordCount, setWordCount] = useState(0);
    const [readingTime, setReadingTime] = useState(0);

    // Load existing post data if editing
    useEffect(() => {
        if (isEditing && postId) {
            setIsLoading(true);
            console.log('Loading post for editing, postId:', postId);

            // Fetch all data in parallel
            Promise.all([
                axios.get(`/post/${postId}`),
                axios.get(`/post/${postId}/data`),
                axios.get(`/post/category/${postId}`),
                axios.get(`/post/${postId}/thumbnail`, { responseType: 'blob' }).catch(() => null)
            ])
                .then(([postResponse, dataResponse, categoriesResponse, thumbnailResponse]) => {
                    console.log('Post metadata response:', postResponse.data);
                    console.log('Post data response:', dataResponse.data);
                    console.log('Post categories response:', categoriesResponse.data);

                    // Set title and subtitle
                    const post = postResponse.data;
                    setTitleText({
                        title: post.title || "",
                        subtitle: post.subtitle || ""
                    });

                    // Set post body/content
                    if (dataResponse.data?.postData) {
                        setMainText(dataResponse.data.postData);
                        // Update word count
                        const plainText = dataResponse.data.postData.replace(/(<([^>]+)>)/gi, '');
                        const words = plainText.trim().split(/\s+/);
                        const count = plainText.trim() === '' ? 0 : words.length;
                        setWordCount(count);
                        setReadingTime(Math.ceil(count / 180));
                    }

                    // Set categories/tags
                    if (categoriesResponse.data && Array.isArray(categoriesResponse.data)) {
                        const existingTags = categoriesResponse.data.map(cat => ({
                            value: cat.name,
                            label: cat.name
                        }));
                        setSelectedOptions(existingTags);
                    }

                    // Set existing thumbnail if available
                    if (thumbnailResponse?.data) {
                        setExistingThumbnail(URL.createObjectURL(thumbnailResponse.data));
                    }
                })
                .catch(err => {
                    console.error('Error loading post:', err);
                    console.error('Error details:', err.response?.data || err.message);
                    alert('Error loading post for editing: ' + (err.response?.data?.message || err.message));
                })
                .finally(() => setIsLoading(false));
        }
    }, [isEditing, postId]);

    // function onImageChange(event) {

    //     setBackgroundImage(event.target.files[0]);
    //     console.log(backgroundImage);

    // }

    function handleChangeTitle(event) {
        const {name, value} = event.target
        setTitleText(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    function handleChangeMain(value) {
        setMainText(value);
        const plainText = value.replace(/(<([^>]+)>)/gi, '');
        const words = plainText.trim().split(/\s+/);
        const count = value.trim() === '' ? 0 : words.length;
        setWordCount(count);
        // Calculate estimated reading time
        const wordsPerMinute = 180; // Adjust this value as desired
        const minutes = Math.ceil(count / wordsPerMinute);
        setReadingTime(minutes);
    }


    async function publish() {
        try {
            const postData = {
                title: titleText.title,
                subtitle: titleText.subtitle,
                postData: mainText
            };

            let savedPostId = postId;

            if (isEditing) {
                // Update existing post
                await axios.put(`/user/post/${postId}`, postData);
            } else {
                // Create new post
                const response = await axios.post('/post', postData);
                savedPostId = response.data?.id || response.data?.post?.id;
            }

            // Upload cover image if one was selected
            if (backgroundImage && savedPostId) {
                const formData = new FormData();
                formData.append('thumbnail', backgroundImage);

                await axios.put(`/user/post/${savedPostId}/thumbnail`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            }

            alert(isEditing ? t('WritePage.SuccessUpdate') : t('WritePage.SuccessPublish'));
            history.replace("/");
        } catch (err) {
            console.error('Error saving post:', err);
            alert('Error saving post: ' + (err.response?.data?.message || err.message));
        }
    }


    if (isLoading) {
        return (
            <div style={{
                maxWidth: '900px',
                margin: '0 auto',
                padding: '80px 20px',
                textAlign: 'center'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '48px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        border: '4px solid #E8DEF8',
                        borderTopColor: '#6750A4',
                        borderRadius: '50%',
                        margin: '0 auto 16px',
                        animation: 'spin 1s linear infinite'
                    }}/>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); }}`}</style>
                    <h2 style={{ margin: '0 0 8px 0', color: '#333' }}>{t('WritePage.Loading')}</h2>
                    <p style={{ margin: 0, color: '#666' }}>{t('WritePage.LoadingDesc')}</p>
                </div>
            </div>
        );
    }

    const sectionStyle = {
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
    };

    const labelStyle = {
        fontSize: '14px',
        fontWeight: '600',
        color: '#333',
        marginBottom: '8px',
        display: 'block',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        fontSize: '16px',
        border: '2px solid #e0e0e0',
        borderRadius: '8px',
        outline: 'none',
        transition: 'border-color 0.2s',
        boxSizing: 'border-box'
    };

    const buttonPrimaryStyle = {
        backgroundColor: '#6750A4',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        padding: '14px 28px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    };

    const buttonSecondaryStyle = {
        backgroundColor: '#fff',
        color: '#6750A4',
        border: '2px solid #6750A4',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s'
    };

    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
            {/* Header */}
            <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                <h1 style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    margin: '0 0 8px 0'
                }}>
                    {isEditing ? t('WritePage.Heading') : t('WritePage.Heading')}
                </h1>
                <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>
                    {isEditing ? t('WritePage.UpdateArticle') : t('WritePage.Subheading')}
                </p>
            </div>

            {/* Cover Image Section */}
            <div style={sectionStyle}>
                <label style={labelStyle}>{t('WritePage.CoverImage')}</label>
                <p style={{ fontSize: '14px', color: '#666', margin: '0 0 16px 0' }}>
                    {t('WritePage.CoverDesc')}
                </p>
                {(backgroundImage || existingThumbnail) && (
                    <div style={{
                        marginBottom: '16px',
                        padding: '16px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                    }}>
                        <p style={{
                            fontSize: '14px',
                            fontWeight: '500',
                            margin: '0 0 12px 0',
                            color: '#28a745',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            {backgroundImage ? t('WritePage.NewCoverSelected') : t('WritePage.CurrentCover')}
                        </p>
                        <img
                            alt="cover preview"
                            src={backgroundImage ? URL.createObjectURL(backgroundImage) : existingThumbnail}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '250px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                display: 'block'
                            }}
                        />
                    </div>
                )}
                <FileUploader onFilesUploaded={handleFilesUploaded}/>
            </div>

            {/* Title & Subtitle Section */}
            <div style={sectionStyle}>
                <div style={{ marginBottom: '20px' }}>
                    <label style={labelStyle}>{t('WritePage.TitleLabel')}</label>
                    <input
                        type="text"
                        name="title"
                        value={titleText.title}
                        onChange={handleChangeTitle}
                        placeholder={t('WritePage.TitlePlaceholder')}
                        maxLength={500}
                        style={inputStyle}
                    />
                </div>
                <div>
                    <label style={labelStyle}>{t('WritePage.SubtitleLabel')}</label>
                    <input
                        type="text"
                        name="subtitle"
                        value={titleText.subtitle}
                        onChange={handleChangeTitle}
                        placeholder={t('WritePage.SubtitlePlaceholder')}
                        maxLength={500}
                        style={inputStyle}
                    />
                </div>
            </div>

            {/* Content Section */}
            <div style={sectionStyle}>
                <label style={labelStyle}>{t('WritePage.ContentLabel')}</label>
                <p style={{ fontSize: '14px', color: '#666', margin: '0 0 16px 0' }}>
                    {t('WritePage.ContentDesc')}
                </p>
                <div style={{
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    marginBottom: '12px'
                }}>
                    <ReactQuill
                        modules={modules}
                        value={mainText}
                        onChange={handleChangeMain}
                        placeholder={t('WritePage.ContentPlaceholder')}
                        className="writeQuill"
                        style={{ minHeight: '350px' }}
                    />
                </div>
                <div style={{
                    display: 'flex',
                    gap: '20px',
                    fontSize: '14px',
                    color: '#666',
                    padding: '12px 16px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px'
                }}>
                    <span><strong>{wordCount}</strong> {t('WritePage.Words')}</span>
                    <span><strong>{readingTime}</strong> {t('WritePage.MinRead')}</span>
                </div>
            </div>

            {/* Tags Section */}
            <div style={sectionStyle}>
                <label style={labelStyle}>{t('WritePage.CategoriesLabel')}</label>
                <p style={{ fontSize: '14px', color: '#666', margin: '0 0 16px 0' }}>
                    {t('WritePage.CategoriesDesc')}
                </p>
                <Select
                    options={coloroptions}
                    isMulti
                    styles={customStyles}
                    onChange={handleSelectChange}
                    value={selectedOptions}
                    placeholder={t('WritePage.CategoriesPlaceholder')}
                />
            </div>

            {/* Action Buttons */}
            <div style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'center',
                marginTop: '32px'
            }}>
                <Popup
                    trigger={<button style={buttonSecondaryStyle}>{t('WritePage.Preview')}</button>}
                    modal
                    contentStyle={{
                        margin: 'auto',
                        background: '#fff',
                        width: '90%',
                        maxWidth: '800px',
                        height: '90%',
                        padding: '32px',
                        border: 'none',
                        borderRadius: '12px',
                        overflow: 'auto',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                    }}
                >
                    {close => (
                        <div>
                            <div style={{ marginBottom: '24px' }}>
                                <h1 style={{ margin: '0 0 8px 0', fontSize: '28px' }}>{titleText.title || 'Untitled'}</h1>
                                <h3 style={{ margin: 0, color: '#666', fontWeight: '400' }}>{titleText.subtitle}</h3>
                            </div>
                            {(backgroundImage || existingThumbnail) && (
                                <div style={{ marginBottom: '24px' }}>
                                    <img
                                        alt="cover"
                                        src={backgroundImage ? URL.createObjectURL(backgroundImage) : existingThumbnail}
                                        style={{
                                            width: '100%',
                                            maxHeight: '300px',
                                            objectFit: 'cover',
                                            borderRadius: '8px'
                                        }}
                                    />
                                </div>
                            )}
                            <div className="preview-content" style={{ marginBottom: '24px' }}>
                                <ReactQuill value={mainText} readOnly={true} theme="bubble"/>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                <button style={buttonSecondaryStyle} onClick={close}>{t('WritePage.ClosePreview')}</button>
                                <button style={buttonPrimaryStyle} onClick={publish}>
                                    {isEditing ? t('WritePage.Update') : t('WritePage.Publish')}
                                </button>
                            </div>
                        </div>
                    )}
                </Popup>
                <button style={buttonPrimaryStyle} onClick={publish}>
                    {isEditing ? t('WritePage.Update') : t('WritePage.Publish')}
                </button>
            </div>
        </div>
    );
}

export default Write;
